import { Container } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import {
  type AfterPageProps,
  createApiClient,
  createInitialPropsRedirectToLogin,
  makeAfterComponent,
  wrapLayout,
} from '../../@sprinx/react-after-razzle';
import commonThingsToLoad from '../../api/commonThingsToLoad';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';
import ContactHqInfo from './components/ContactHqInfo';
import ContactInfoSection from './components/ContactInfoSection';
import { contactInfoSections, hqInfo } from './ContactsPage.constants';

export type ContactsPageProps = AfterPageProps;
export type ContactsPageClassNameKey =
  | 'root'
  | 'personFrame'
  | 'firstSection'
  | 'firstSectionRow'
  | 'firstSectionInfoBox'
  | 'secondSection'
  | 'secondSectionRow'
  | 'subtitle'
  | 'sectionThree'
  | 'personsFrameWrapper'
  | 'sectionFour'
  | 'mapNumber'
  | 'map'
  | 'departmentManager'
  | 'lastChildCenter';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '5rem',
    },
  }),
);

const ContactsPage: React.FC<ContactsPageProps> = () => {
  const classes = useStyles();

  return (
    <Container>
      <div className={classes.root}>
        {contactInfoSections.map((section, index) => (
          <ContactInfoSection data={section} key={index} />
        ))}
        <ContactHqInfo data={hqInfo} />
      </div>
    </Container>
  );
};

ContactsPage.displayName = 'ContactsPage';

export default makeAfterComponent(
  wrapLayout<ContactsPageProps>(ContactsPage, InfoLayout),
  async ({ match, initialAppProps }) => {
    try {
      if (initialAppProps) {
        const appProps = initialAppProps;
        const apiClient = createApiClient({ accessToken: appProps.auth?.accessToken });
        const commonThings = await Promise.all(commonThingsToLoad.promises({ apiClient }));
        appProps.propagateToState({
          ...commonThingsToLoad.toRegister(commonThings),
        });
      }
      return {};
    } catch (error) {
      if (error.response?.status === 401) {
        return createInitialPropsRedirectToLogin({ match });
      }
      return { error };
    }
  },
);
